import { normalSanatizerBRL } from "src/utils/functions";
import { ResultSalario } from "../Ferias";
export const FeriasTable = ({
    results
}: {
    results: ResultSalario
}) => {
    return (
        <div className="max-h-[400px] overflow-y-auto m-auto overflow-x-auto">
            <table className="bg-white rounded w-full max-h-[400px] overflow-y-auto">
                <thead className="bg-gray-200 sticky top-0">
                    <tr>
                        <th className="px-4 py-2 text-center truncate">Evento</th>
                        <th className="px-4 py-2 text-center truncate">Ref.</th>
                        <th className="px-4 py-2 text-center truncate">Proventos</th>
                        <th className="px-4 py-2 text-center truncate">Descontos</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            Valor Férias
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            -
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            R$ {normalSanatizerBRL(results.ValorFerias)}
                        </td>
                        <td className="px-4 py-2 text-center truncate">
                            -
                        </td>
                    </tr>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            1/3 férias
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            -
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            R$ {normalSanatizerBRL(results.Umterço)}
                        </td>
                        <td className="px-4 py-2 text-center truncate">
                            -
                        </td>
                    </tr>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            Abono
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            -
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            R$ {normalSanatizerBRL(results.ValorAbono)}

                        </td>
                        <td className="px-4 py-2 text-center truncate">
                        </td>
                    </tr>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            1/3 Abono
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            -
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            R$ {normalSanatizerBRL(results.UmterçoAbono)}

                        </td>
                        <td className="px-4 py-2 text-center truncate">
                        </td>
                    </tr>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            Adiantamento 1ª Parcela 13º
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            -
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            R$ {normalSanatizerBRL(results.decimoterceiro)}

                        </td>
                        <td className="px-4 py-2 text-center truncate">
                        </td>
                    </tr>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            INSS
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            {results.PorcentagemINSS}%
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            -
                        </td>
                        <td className="px-4 py-2 text-center truncate">
                            R$ {normalSanatizerBRL(results.ValorINSS)}
                        </td>
                    </tr>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            IRRF
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            {results.PorcentagemIRRF}%
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            -
                        </td>
                        <td className="px-4 py-2 text-center truncate">
                            R$ {normalSanatizerBRL(results.ValorIRFF)}
                        </td>
                    </tr>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            Totais
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            -
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            R$ {normalSanatizerBRL(results.totais)}
                        </td>
                        <td className="px-4 py-2 text-center truncate">
                            -
                        </td>
                    </tr>
                    <tr className="border-b">
                        <td className="px-4 py-2 text-center border-r">
                            VALOR FÉRIAS LÍQUIDO
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            -
                        </td>
                        <td className="px-4 py-2 text-center  truncate border-r" >
                            R$ {normalSanatizerBRL(results.valorfinal)}
                        </td>

                    </tr>
                </tbody>
            </table>

        </div>
    )
}